import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["onLinkClick", "name", "value", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Checkbox } from '@hub/checkbox';
import { Link } from '@hub/link';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useRouter } from '../../../../apps/website/lib/router';
import { jsx as _jsx } from "react/jsx-runtime";

const createLinkFromCheckboxValue = (pathname, search, name, value) => {
  const usp = new URLSearchParams(search);
  let values = usp.getAll(name);

  if (values.includes(value)) {
    values = values.filter(x => x !== value);
  } else {
    values.push(value);
  }

  usp.delete(name);
  values.sort().forEach(val => usp.append(name, val));
  return "".concat(pathname, "?").concat(usp.toString());
};

export const CheckboxWithLink = _ref => {
  let {
    onLinkClick,
    name,
    value,
    children
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  const {
    basePath
  } = useRouter();
  const {
    pathname,
    search
  } = useLocation();
  const href = React.useMemo(() => createLinkFromCheckboxValue("".concat(basePath).concat(pathname), search, name, value), [basePath, pathname, search, name, value]);
  return /*#__PURE__*/_jsx(Checkbox, _objectSpread(_objectSpread({
    value: value
  }, props), {}, {
    "data-id": "searchable-faceted-filter_checkbox-with-link_CheckboxWithLink_Checkbox",
    children: /*#__PURE__*/_jsx(Link, {
      href: href,
      hasUnderline: false,
      onClick: onLinkClick,
      "data-id": "searchable-faceted-filter_checkbox-with-link_CheckboxWithLink_Checkbox_Link",
      children: children
    })
  }));
};